import { ChartTimeSeriesLineTheme } from '@hcs/design-system';
import { DateStr } from '@hcs/types';
import { CerberusStatsFields } from '@hcs/types';

import { CerberusStatsListingStatsChart } from '../../components/CerberusStatsListingStatsChart';
import { MACRO_INSIGHTS_FROM_DATE } from '../../constants/marketInsights.constants';
import { useCityListingStatsTimeSeries } from '../../hooks/useCityListingStatsTimeSeries';
import { getIsRentalListingStatsField } from '../../utils/cerberusStatsConfig.utils';

interface CityListingStatsLineChartProps {
  className?: string;
  placeId: string;
  fromDate?: DateStr;
  toDate?: DateStr;
  cerberusStatsField: CerberusStatsFields;
  theme?: Partial<ChartTimeSeriesLineTheme>;
}

export const CityListingStatsChart = ({
  className,
  placeId,
  fromDate = MACRO_INSIGHTS_FROM_DATE,
  toDate,
  cerberusStatsField,
  theme,
}: CityListingStatsLineChartProps) => {
  const dataHcName = `city-${cerberusStatsField}-chart`;
  const { data, isLoading } = useCityListingStatsTimeSeries({
    placeId,
    fromDate,
    toDate,
  });
  const isRentalField = getIsRentalListingStatsField(cerberusStatsField);

  return (
    <CerberusStatsListingStatsChart
      dataHcName={dataHcName}
      className={className}
      theme={theme}
      cerberusStatsField={cerberusStatsField}
      isRentalField={isRentalField}
      isLoading={isLoading}
      data={isRentalField ? data?.rentalListingStats : data?.saleListingStats}
    />
  );
};
